var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdatePersonalDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 18.1745H16.6578C15.9467 18.1745 15.2711 18.4537 14.7733 18.958L13.2533 20.4799C12.56 21.1734 11.4311 21.1734 10.7378 20.4799L9.21777 18.958C8.72 18.4537 8.03556 18.1745 7.33333 18.1745H6.66667C5.19111 18.1745 4 16.9768 4 15.4998V5.67465C4 4.19772 5.19111 3 6.66667 3H17.3333C18.8089 3 20 4.19772 20 5.67465V15.4998C20 16.9678 18.8089 18.1745 17.3333 18.1745Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 10.0018C13.2868 10.0018 14.33 8.95858 14.33 7.67175C14.33 6.38493 13.2868 5.3418 11.9999 5.3418C10.7131 5.3418 9.66992 6.38493 9.66992 7.67175C9.66992 8.95858 10.7131 10.0018 11.9999 10.0018Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.6633C16 13.8633 14.21 12.4033 12 12.4033C9.79 12.4033 8 13.8633 8 15.6633",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePersonalDetails);
export default __webpack_public_path__ + "static/media/UpdatePersonalDetails.523da90b37897d48faf51f11fb2976cc.svg";
export { ForwardRef as ReactComponent };